// @ts-nocheck

import React, { useEffect, useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import {
  editPublication,
  getPublicationById,
} from "../../../features/publication";
import DashboardNavbar from "../../../components/navbars/dashboardNavbar";
import { FormControl, MenuItem, Select } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
const EditPublication = () => {
  const { id } = useParams<{ id: string }>();
  const { publication, status } = useSelector(
    (state: any) => state.publication
  );
  const [language, setLanguage] = useState("en");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: "", // Title of the publication
    description: "", // Description of the publication
    photo: null, // Image for the publication
  });

  useEffect(() => {
    setFormData({
      title: "",
      description: "",
      photo: null,
    });
    dispatch(getPublicationById({ id, lan: language }));
  }, [dispatch, id, language]);
  // // // console.log(publication,'publication');

  useEffect(() => {
    if (status && publication) {
      const data = publication.data;
      setFormData({
        title: data.title,
        description: data.description,
        photo: data.photo,
      });
    }
  }, [status, publication]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePhotoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormData((prev) => ({
        ...prev,
        photo: e.target.files[0],
      }));
    }
  };

  const handleSubmit = () => {
    if (!formData.title.trim()) {
      toast.error("Title is required.");
      return;
    }
    if (!formData.description.trim()) {
      toast.error("Description is required.");
      return;
    }
    const formDataFinal = new FormData();

    formDataFinal.append("folder_name", "publication"); // Static folder_name
    formDataFinal.append("language", language);

    Object.entries(formData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formDataFinal.append(key, value);
      }
    });

    dispatch(
      editPublication({ id, updatedPublication: formDataFinal, lan: language })
    )
      .then((resultAction) => {
        if (editPublication.rejected.match(resultAction)) {
          // This means it was a rejection, handle error
          // toast.error("An error occurred while creating the Publication.");
          console.error(resultAction.payload || resultAction.error);
        } else {
          navigate("/publication");
          toast.success("Publication updated successfully!");
        }
      })
      .catch((err) => {
        console.error(err, "error");
        toast.error("An error occurred while updating the publication.");
      });
  };

  return (
    <SoftBox className="language-box">
      <DashboardNavbar />

      {/* Form Container */}
      <SoftBox>
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
            Edit Publication
          </SoftTypography>
        </SoftBox>

        <SoftBox component="form" role="form">
          {/* Language Input */}
          <SoftBox mb={2}>
            <FormControl fullWidth size="small">
              <SoftTypography
                htmlFor="language"
                style={{
                  fontSize: "15px ",
                  fontWeight: "500",
                  lineHeight: "normal",
                  marginBottom: "10px",
                }}
              >
                Language
              </SoftTypography>
              <Select
                id="language"
                name="language"
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                IconComponent={KeyboardArrowDownIcon}
                    fullWidth
                    size="small"
                    sx={{
                      padding: "0px 8px !important",
                      height: "40px !important",
                      display: "block !important",
                      ".MuiSelect-select": {
                        padding: "0px 8px !important",
                        height: "40px !important",
                      },
                      ".MuiSelect-nativeInput": {
                        height: "40px !important",
                      },
                      ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                      ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                    }}
              >
                <MenuItem style={{ marginBottom: "5px" }} value="en">
                  English
                </MenuItem>
                <MenuItem value="ar">Arabic</MenuItem>
              </Select>
            </FormControl>
          </SoftBox>

          {/* Title Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Title
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="title"
              placeholder="Enter the title"
              value={formData.title}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Description Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Description
              </SoftTypography>
            </SoftBox>
            <textarea
              name="description"
              placeholder="Enter the description"
              value={formData.description}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            />
          </SoftBox>

          {/* Photo Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Photo
              </SoftTypography>
            </SoftBox>
            {formData.photo && (
              <img
                src={
                  typeof formData.photo !== "string"
                    ? URL.createObjectURL(formData.photo)
                    : formData.photo
                }
                alt="Publication"
                style={{ width: "150px", height: "150px", borderRadius: "5px" }}
              />
            )}
            <input
              type="file"
              name="photo"
              onChange={handlePhotoChange}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }}
            />
          </SoftBox>

          {/* Submit Button */}
          <SoftBox mt={4} mb={1}>
            <SoftButton
              variant="gradient"
              color="info"
              fullWidth
              onClick={handleSubmit}
            >
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default EditPublication;
